module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MediGridItemVimeo"
  }, [(_vm.data.route || _vm.data.hash) ? [_c('vimeo-thumbnail', _vm._b({}, 'vimeo-thumbnail', _vm.data, false))] : [_c('vimeo', _vm._b({}, 'vimeo', _vm.data, false))], _vm._v(" "), _c('media-grid-item-title', {
    attrs: {
      "data": _vm.data
    }
  }), _vm._v(" "), _c('media-grid-item-description', {
    attrs: {
      "data": _vm.data
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bbff546"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemVimeo.vue
// module id = 746
// module chunks = 1474